export default __webpack_public_path__ + "static/O0202-ffe21550943b4d9c341650faa1fb5c15.png";